import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { styles } from "./ConfStylling";
import Huge from "./wipro-logo.png";
import Uncheck from "./checkbox_unchecked.png";
import Check from "./Checked.PNG";
import Stop from "./stop.PNG";
export default function ConfPdf(props) {
   //console.log("cls",props?.pdfData)
  return (
    <Document>
      <Page size="A4" wrap={false} style={styles.document}>
        <View style={styles.header0}>
          <Text>OMB No. 0938-1378</Text>
          <Text>Expires:7/31/2023</Text>
        </View>

        <View style={styles.headerContainer}>
          <View style={styles.header1}>
            <Image src={Huge} alt="image"></Image>
          </View>
          <View style={styles.header2}>
            <Text>INDIVIDUAL ENROLLMENT REQUEST</Text>
            <Text>FORM TO ENROLL IN A MEDICARE</Text>
            <Text>ADVANTAGE PLAN (PART C)</Text>
          </View>
        </View>
        <View style={styles.page1Content}>
          <View style={styles.page1LeftContent}>
            <View style={{ marginBottom: 10 }}>
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 10,
                  fontSize: 14,
                }}
              >
                Who can use this form?
              </Text>
              <Text>People with Medicare who want to join a Medicare</Text>
              <Text>Advantage Plan</Text>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 10 }}>
                To join a plan, you must:
              </Text>
              <View style={{ marginLeft: 30, marginBottom: 10 }}>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    marginBottom: 10,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text> Be a United States citizen or be lawfully</Text>
                    <Text>present in the U.S.</Text>
                  </View>
                </View>
                <View style={{ display: "flex", flexDirection: "row" }}>
                  <Text style={styles.dot}>•</Text>
                  <Text>Live in the plan’s service area</Text>
                </View>
              </View>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text style={{ fontFamily: "Helvetica-Bold", fontsize: 11 }}>
                Important: To join a Medicare Advantage Plan,
              </Text>
              <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 10 }}>
                you must also have both:
              </Text>
              <View style={{ marginLeft: 30, marginBottom: 10 }}>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    marginBottom: 10,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text> Medicare Part A (Hospital Insurance)</Text>
                  </View>
                </View>
                <View style={{ display: "flex", flexDirection: "row" }}>
                  <Text style={styles.dot}>•</Text>
                  <Text>Medicare Part B (Medical Insurance)</Text>
                </View>
              </View>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 10,
                  fontSize: 14,
                }}
              >
                When do I use this form?
              </Text>
              <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 10 }}>
                You can join a plan
              </Text>
              <View style={{ marginLeft: 30, marginBottom: 10 }}>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    marginBottom: 10,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text>Between October 15–December 7 each</Text>
                    <Text>year (for coverage starting January 1)</Text>
                  </View>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: 10,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <Text>Within 3 months of first getting Medicare</Text>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text>In certain situations where you’re allowed</Text>
                    <Text>to join or switch plans</Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text>Visit Medicare.gov to learn more about when you</Text>
              <Text>can sign up for a plan.</Text>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 10,
                  fontSize: 14,
                }}
              >
                What do I need to complete this form?
              </Text>
              <View style={{ marginLeft: 30, marginBottom: 10 }}>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    marginBottom: 10,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text>Your Medicare Number (the number on</Text>
                    <Text>your red, white, and blue Medicare card)</Text>
                  </View>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text>Your permanent address and phone</Text>
                    <Text>number</Text>
                  </View>
                </View>
              </View>
            </View>
            <View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 10,
                }}
              >
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Note: </Text>
                <Text>: You must complete all items in Section 1.</Text>
              </View>
              <Text>The items in Section 2 are optional — you can’t be</Text>
              <Text>denied coverage because you don’t fill them out.</Text>
            </View>
          </View>

          <View style={styles.page1RightContent}>
            <View style={{ marginBottom: 10 }}>
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 10,
                  fontSize: 14,
                }}
              >
                Reminders:
              </Text>
              <View style={{ marginLeft: 30, marginBottom: 10 }}>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    marginBottom: 10,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text>If you want to join a plan during fall open</Text>
                    <Text>enrollment (October 15–December 7),</Text>
                    <Text>the plan must get your completed form</Text>
                    <Text>by December 7</Text>
                  </View>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text>Your plan will send you a bill for the plan’s</Text>
                    <Text>premium. You can choose to sign up to have</Text>
                    <Text>your premium payments deducted from your</Text>
                    <Text>bank account or your monthly Social Security</Text>
                    <Text>(or Railroad Retirement Board) benefit.</Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 10,
                  fontSize: 14,
                }}
              >
                What happens next?
              </Text>
              <Text style={{ marginBottom: 10 }}>
                Send your completed and signed form to:
              </Text>
              <View style={{ marginLeft: 30, marginBottom: 10 }}>
                <View style={styles.dotLine}>
                  <Text>{"<Wipro Elite"}</Text>
                  <Text>PO Box 4250</Text>
                  <Text>{"Richmond, VA 23220-8250>"}</Text>
                </View>
              </View>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text>Once they process your request to join, they’ll</Text>
              <Text>contact you.</Text>
            </View>
            <View style={{ marginBottom: 10 }}>
              <Text
                style={{
                  fontFamily: "Helvetica-Bold",
                  marginBottom: 10,
                  fontSize: 14,
                }}
              >
                How do I get help with this form?
              </Text>
              <Text>{"Call Wipro Elite at <1-888-123-1111>. TTY users"}</Text>
              <Text style={{ marginBottom: 10 }}>can call 711.</Text>
              <Text style={{ fontSize: 10 }}>
                Or, call Medicare at 1-800-MEDICARE (1-800-633-4227).
              </Text>
              <Text>TTY users can call 1-877-486-2048.</Text>
            </View>
            <View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  position: "relative",
                }}
              >
                <Text style={{ fontFamily: "Helvetica-Bold" }}>
                  En español:{" "}
                </Text>
                <Text>Llame a Wipro Elite al</Text>
              </View>
              <Text>{"<1-888-123-1111> (TTY: 711) o a Medicare gratis "}</Text>
              <Text>al 1-800-633-4227 y oprima el 2 para asistencia en </Text>
              <Text>español y un representante estará disponible</Text>
              <Text>para asistirle.</Text>
            </View>
          </View>
        </View>
        <Text style={{ textAlign: "right", fontSize: 11, paddingTop: 100 }}>
          {"<H1234_0123_WIP2-001235_W>"}
        </Text>
      </Page>
      <Page size="A4" wrap={false} style={styles.document}>
        <View>
          <View style={styles.page2Header}>
            <Image src={Huge} alt="image" style={styles.header1} />
            <View style={styles.page2HeaderLine}>
              <Text>Please contact Wipro Elite if you need</Text>
              <Text>information in another language or format (Braille)</Text>
            </View>
          </View>
          <View style={styles.page2HeaderBox}>
            <Text style={{ paddingBottom: 5 }}>
              This Plan Requires Individuals to Have Both Medicare and Medicaid
              Coverage
            </Text>
            <Text style={{ paddingBottom: 5, marginLeft: 10, marginRight: 10 }}>
              To Enroll in Wipro Elite Advantage Elite (HMO D-SNP), Please
              Provide the Following Information:
            </Text>
          </View>
          <View style={styles.nameInfoContainer}>
            <View style={styles.nameInfo}>
              <Text>LAST Name:</Text>
              <Text>{props.pdfData.lastName}</Text>
            </View>
            <View style={styles.nameInfo}>
              <Text>FIRST Name:</Text>
              <Text>{props.pdfData.firstName}</Text>
            </View>
            <View style={styles.nameInfo1}>
              <Text>[Optional: Middle Initial]:</Text>
              <Text>{props.pdfData.middleInitial}</Text>
            </View>
            <View style={styles.prefixContainer}>
              <View style={styles.prefixElement}>
                <Image
                  src={props.pdfData.prefix === "MR." ? Check : Uncheck}
                  alt="Image"
                  style={{ width: 12, height: 12, margin: 2 }}
                />
                <Text style={{ margin: 2 }}>Mr.</Text>
              </View>
              <View style={styles.prefixElement}>
                <Image
                  src={props.pdfData.prefix === "MS." ? Check : Uncheck}
                  style={{ width: 12, height: 12, margin: 2 }}
                  alt="Image"
                />
                <Text style={{ margin: 2 }}>Ms.</Text>
              </View>
              <View style={styles.prefixElement}>
                <Image
                  src={props.pdfData.prefix === "MRS." ? Check : Uncheck}
                  style={{ width: 12, height: 12, margin: 2 }}
                  alt="Image"
                />
                <Text style={{ margin: 2 }}>Mrs.</Text>
              </View>
              <View style={styles.prefixElement}>
                <Image
                  src={props.pdfData.prefix === "DR." ? Check : Uncheck}
                  style={{ width: 12, height: 12, margin: 2 }}
                  alt="Image"
                />
                <Text style={{ margin: 2 }}>Dr.</Text>
              </View>
            </View>
          </View>
          <View style={styles.dateContainer}>
            <View style={styles.birthDtCnt}>
              <Text style={styles.birthDt}>BirthDate:</Text>
              <View
                style={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: 10,
                  margin: 4,
                  marginBottom: 0,
                }}
              >
                <Text style={{ marginBottom: 3 }}>
                  {props.pdfData.birthDate}
                </Text>
                {/* <Text>
                  (MM/DD/YYYY)
                </Text> */}
              </View>
            </View>
            <View style={styles.sexCnt}>
              <View style={{ margin: 4 }}>
                <Text style={{ marginBottom: 3 }}>Sex:</Text>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontSize: 10,
                  }}
                >
                  <Image
                    src={props.pdfData.sex === "M" ? Check : Uncheck}
                    alt="Image"
                    style={{
                      width: 12,
                      height: 12,
                      margin: 3,
                      marginBottom: 0,
                    }}
                  />
                  <Text style={{ margin: 3 }}>M</Text>
                  <Image
                    src={props.pdfData.sex === "F" ? Check : Uncheck}
                    alt="Image"
                    style={{
                      width: 12,
                      height: 12,
                      margin: 3,
                      marginBottom: 0,
                    }}
                  />
                  <Text style={{ margin: 3 }}>F</Text>
                  <Image
                    src={props.pdfData.sex === "U" ? Check : Uncheck}
                    alt="Image"
                    style={{
                      width: 12,
                      height: 12,
                      margin: 3,
                      marginBottom: 0,
                    }}
                  />
                  <Text style={{ margin: 3 }}>U</Text>
                </View>
              </View>
            </View>
            <View style={styles.sexCnt}>
              <View style={{ margin: 4 }}>
                <Text style={{ marginBottom: 3, marginRight: 5 }}>
                  Home Phone Number:
                </Text>
                <Text>
                  {"(" +
                    props.pdfData.primaryPhoneNum.slice(0, 3) +
                    ") " +
                    props.pdfData.primaryPhoneNum.slice(3, 6) +
                    " -" +
                    props.pdfData.primaryPhoneNum.slice(6)}
                </Text>
              </View>
            </View>
            <View style={styles.sexCnt1}>
              <View style={{ margin: 4 }}>
                <Text style={{ marginBottom: 3, marginRight: 3 }}>
                  Optional field: Alternate Phone Number:
                </Text>
                <Text>
                  {props.pdfData.cellPhoneNum.length === 10
                    ? "(" +
                      props.pdfData.cellPhoneNum.slice(0, 3) +
                      ") " +
                      props.pdfData.cellPhoneNum.slice(3, 6) +
                      " -" +
                      props.pdfData.cellPhoneNum.slice(6)
                    : props.pdfData.cellPhoneNum}
                </Text>
              </View>
            </View>
          </View>
          {/* <View style={styles.page2paraCnt}>
          <View style={styles.page2Para}>
            <View style={{display:"flex",flexDirection:"row"}}>
              <Image
              src={Uncheck}
              alt="Image"
              style={{width:12,height:12}}
              />
              <Text style={{fontFamily:"Times-Roman",fontSize:10}}>
                {"<By checking this box, you are consenting to Wipro Elite and its representatives contacting you at any phone number you "}
              </Text>
            </View>
            <Text style={{fontFamily:"Times-Roman",fontSize:11}}>
              have provided to us, which may include mobile phone numbers. You understand that you are not required to agree, and agreeing
              is not a condition of being an Wipro Elite member or receiving health care. Communications directed to these phone numbers
              may be carried out using automated dialing/delivery devices, direct dial, text message, SMS (short message service) or RCS (rich
              communication services) messages, ringless voicemail, and prerecorded or artificial voices. Communications may include, but may not
              be limited to, information regarding medication, wellness, preventive care, communication preferences, and payment. Communications
              and their content, which may include health information, will not be encrypted. You may revoke this consent at any time. To opt out
              of phone calls, call 1-888-123-1111. To opt out of text messages, text STOP to short code 59270 or call 1-888-123-1111. If you are not
              the subscriber to the phone number you provided, then you agree that you have obtained the subscriber’s consent to receive these
              communications. Wipro Elite will not charge you for these communications. Carrier message and data rates may apply.>
            </Text>
          </View>
          </View> */}
          {/* <View style={styles.page2paraCnt}>
            <View style={{marginLeft:20}}>
            <View style={{display:"flex",flexDirection:"row"}}>
              <Text>
              Email Address:
              </Text>
              <View style={{display:"flex",flexDirection:"column"}}>
                <Text style={{marginBottom:3}}>
                  {props.pdfData.emailAddress}
                </Text>
                <Text style={styles.underLine}>
                </Text>
              </View>
            </View>
            <View style={{display:"flex",flexDirection:"row",marginBottom:3}}>
                <Image
                src={Uncheck}
                alt="Image"
                style={{width:12,height:12,marginRight:6}}
                />
                <View style={{display:"flex",flexDirection:"column"}}>
                  <Text>
                  I give Wipro Elite permission to send my plan materials and member communications, excluding
                  </Text>
                  <Text>
                  EOBs, by email.
                  </Text>
                </View>
            </View>
            </View>
          </View> */}
          <View style={styles.underLine}>
            <View style={styles.alligner}>
              <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 4 }}>
                Permanent Residence Street Address (P.O. Box is not allowed):
              </Text>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 4,
                }}
              >
                <Text>Street Address:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>
                    {props.pdfData.permanentAddress.address2
                      ? props.pdfData.permanentAddress.streetAddress +
                        "," +
                        props.pdfData.permanentAddress.address2
                      : props.pdfData.permanentAddress.streetAddress}
                  </Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              {/* <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 4,
                }}
              >
              <Text>Address2:</Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{props.pdfData.permanentAddress.address2}</Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                  </View> */}
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 4,
                fontSize: 11,
                marginLeft: 20,
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Text>City:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>{props.pdfData.permanentAddress.city}</Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: 30,
                  marginBottom: 4,
                }}
              >
                <Text> County:</Text>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 20,
                  }}
                >
                  <Text>
                    {props.pdfData.permanentCnt
                      ? props.pdfData.permanentCnt
                      : props.pdfData.permanentAddress.county}
                  </Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: 20,
                  marginBottom: 4,
                }}
              >
                <Text>State:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>{props.pdfData.permanentAddress.state}</Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginLeft: 20,
                  marginBottom: 4,
                }}
              >
                <Text>ZIP Code:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>
                    {props.pdfData.permanentAddress.zip4
                      ? props.pdfData.permanentAddress.zipCode +
                        "-" +
                        props.pdfData.permanentAddress.zip4
                      : props.pdfData.permanentAddress.zipCode}
                  </Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              {/* <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: 20,
                    marginBottom: 4,
                  }}
                >
                  <Text>ZIP+4:</Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{props.pdfData.permanentAddress.zip4}</Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                </View> */}
            </View>
          </View>
          <View style={styles.underLine}>
            <View style={styles.alligner}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 4,
                }}
              >
                <Text style={{ fontFamily: "Helvetica-Bold" }}>
                  Mailing Address
                </Text>
                <Text>
                  (only if different from your Permanent Residence Address):
                </Text>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 4,
                }}
              >
                <Text>Street Address:</Text>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 60,
                  }}
                >
                  <Text>
                    {props.pdfData.mailingAddress.address2
                      ? props.pdfData.mailingAddress.streetAddress +
                        "," +
                        props.pdfData.mailingAddress.address2
                      : props.pdfData.mailingAddress.streetAddress}
                  </Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              {/* <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 4,
                }}
              >
              <Text>Address2:</Text>
                  <View style={{ display: "flex", flexDirection: "column"}}>
                    <Text>{props.pdfData.mailingAddress.address2}</Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                </View> */}
            </View>
            <View style={{ display: "flex", flexDirection: "row" }}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 4,
                  fontSize: 11,
                  marginLeft: 20,
                }}
              >
                <Text>City:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>{props.pdfData.mailingAddress.city}</Text>
                  <Text style={styles.underLine}></Text>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: 60,
                    marginBottom: 4,
                  }}
                >
                  <Text>State:</Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{props.pdfData.mailingAddress.state}</Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: 30,
                    marginBottom: 4,
                  }}
                >
                  <Text>ZIP Code:</Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>
                      {props.pdfData.mailingAddress.zip4
                        ? props.pdfData.mailingAddress.zipCode +
                          "-" +
                          props.pdfData.mailingAddress.zip4
                        : props.pdfData.mailingAddress.zipCode}
                    </Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                </View>
                {/* <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginLeft: 30,
                    marginBottom: 4,
                  }}
                >
                  <Text>ZIP+4:</Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{props.pdfData.mailingAddress.zip4}</Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                </View> */}
              </View>
            </View>
          </View>
          {/* <View style={styles.underLine}>
            <View style={styles.alligner}>
                <View style={{display:"flex",flexDirection:"row",marginBottom:4,marginTop:4}}>
                  <Text style={{fontFamily:"Helvetica-Oblique"}}>
                  Optional field 
                  </Text>
                  <Text> </Text>
                  <Text style={{fontFamily:"Helvetica-Bold"}}>
                Emergency contact:
                </Text>
                  <View style={{display:"flex",flexDirection:"column"}}>
                  <Text>
                    {props.pdfData.addressOfRep}
                  </Text>
                <Text style={styles.underLine}>
                </Text>
              </View>
                </View>
                <View style={{display:"flex",flexDirection:"row"}}>
              <View style={{display:"flex",flexDirection:"row",marginBottom:4}}>
                <Text style={{fontFamily:"Helvetica-Bold"}}>Phone Number:</Text>
                <Text>
                  {props.pdfData.phoneNumberOfRep}
                  </Text>
              </View>
              <View style={{display:"flex",flexDirection:"row",marginLeft:60,marginBottom:4}}>
                <Text style={{fontFamily:"Helvetica-Bold"}}>
                Relationship to You:
                </Text>
                <Text>
                  {props.pdfData.relationOfRep}
                </Text>
              </View>
            </View>
            </View>
          </View> */}
          <View style={styles.alligner}>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 4,
                marginTop: 4,
              }}
            >
              <Text style={{ fontFamily: "Helvetica-Oblique" }}>
                Optional field
              </Text>
              <Text> </Text>
              <Text style={{ fontFamily: "Helvetica-Bold" }}>
                : E-mail Address:
              </Text>
              <View style={{ display: "flex", flexDirection: "column" }}>
                <Text>{props.pdfData.emailAddress}</Text>
              </View>
            </View>
          </View>
          <View style={styles.page2HeaderBox}>
            <Text
              style={{
                paddingBottom: 6,
                marginTop: 6,
                fontSize: 12,
                fontFamily: "Helvetica-Bold",
              }}
            >
              Please Provide Your Medicare Insurance Information
            </Text>
          </View>
          <View></View>
          <View style={{ display: "flex", flexDirection: "row" }}>
            <View style={styles.alligner}>
              <Text style={{ fontSize: 12 }}>
                Please take out your red, white and blue
              </Text>
              <Text style={{ fontSize: 12 }}>
                Medicare card to complete this section.
              </Text>
              <View style={{ marginLeft: 30, marginBottom: 10 }}>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    marginBottom: 10,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={styles.dotLine}>
                    <Text style={{ fontSize: 12 }}>
                      Fill out this information as it appears
                    </Text>
                    <Text style={{ fontSize: 12 }}>on</Text>
                    <Text style={{ fontSize: 12 }}>your Medicare card.</Text>
                    <Text style={{ fontSize: 12 }}>-OR-</Text>
                  </View>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontSize: 12,
                  }}
                >
                  <Text style={styles.dot}>•</Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>Attach a copy of your Medicare card</Text>
                    <Text>or your letter from Social Security or</Text>
                    <Text>the Railroad Retirement Board.</Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.verticalLine}></View>
            <View style={{ fontSize: 12 }}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 13,
                }}
              >
                <View
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: 15,
                  }}
                >
                  <Text>{"Name (as it appears"}</Text>
                  <Text>{"on your Medicare Card):"}</Text>
                </View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: 100,
                  }}
                >
                  <Text>
                    {props.pdfData.firstName +
                      " " +
                      props.pdfData.middleInitial +
                      " " +
                      props.pdfData.lastName}
                  </Text>
                  <Text style={{ ...styles.underLine, width: 100 }}></Text>
                  {/* <Text style={{ fontSize: 8, marginTop: 3, marginBottom: 3 }}>
                    PRINT NAME
                  </Text>
                  <Text>
                    {props.pdfData.name}
                  </Text>
                  <Text style={styles.underLine}>
                  </Text>
                  <Text style={{ fontSize: 8, marginTop: 3, marginBottom: 3 }}>
                    signature
                  </Text> */}
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 13,
                }}
              >
                <Text style={{ marginRight: 7 }}>Medicare Number:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>{props.pdfData.medicareNumber}</Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              <View>
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: 13,
                  }}
                >
                  <Text>Is Entitled to</Text>
                  <Text>Effective Dates:</Text>
                </View>
                <View style={{ display: "flex", flexDirection: "row" }}>
                  <Text style={{ marginLeft: 20, marginRight: 17 }}>
                    HOSPITAL (Part A)
                  </Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{props.pdfData.partAEffDate}</Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                </View>
                <View style={{ display: "flex", flexDirection: "row" }}>
                  <Text style={{ marginLeft: 20, marginRight: 17 }}>
                    MEDICAL (Part B)
                  </Text>
                  <View style={{ display: "flex", flexDirection: "column" }}>
                    <Text>{props.pdfData.partBEffDate}</Text>
                    <Text style={styles.underLine}></Text>
                  </View>
                </View>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>*****You must have Medicare Part A and Part B </Text>
                  <Text>to join a Medicare Advantage plan.</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        <Text style={{ textAlign: "right", fontSize: 11, paddingTop: 280 }}>
          {"<H1234_0123_WIP2-001235_W>"}
        </Text>
      </Page>
      <Page size="A4" wrap={false} style={styles.document}>
        <View style={styles.page3Container}>
          <View
            style={{
              paddingBottom: 6,
              fontSize: 13,
              fontFamily: "Helvetica-Bold",
              textAlign: "center",
              backgroundColor: "#DCDCDC",
            }}
          >
            <Text style={{ marginTop: 8, marginBottom: 8 }}>
              Please read and answer these important questions:
            </Text>
          </View>
          <Text style={styles.underLine}></Text>
          <View style={{ margin: 12, fontSize: 12, marginBottom: 20 }}>
            <Text>
              1. Some individuals may have other drug coverage, including other
              private insurance, TRICARE, Federal
            </Text>
            <Text>
              employee health benefits coverage, VA benefits, or State
              pharmaceutical assistance programs
            </Text>
          </View>
          <View
            style={{
              margin: 12,
              fontSize: 12,
              marginTop: 0,
              display: "flex",
              flexDirection: "row",
              marginBottom: 3,
            }}
          >
            <Text style={{ marginRight: 4 }}>
              Will you have other prescription drug coverage in addition to
              Wipro Health Plan?
            </Text>
            <Image
              src={props.pdfData.isDrugCoverage === "Y" ? Check : Uncheck}
              alt="Image"
              style={{ width: 12, height: 12, marginRight: 4 }}
            />
            <Text style={{ marginRight: 4 }}>Yes</Text>
            <Image
              src={props.pdfData.isDrugCoverage !== "Y" ? Check : Uncheck}
              alt="Image"
              style={{ width: 12, height: 12, marginRight: 4 }}
            />
            <Text>No</Text>
          </View>
          <Text style={{ marginLeft: 12, marginTop: 0, marginBottom: 6 }}>
            If “yes”, please list your other coverage and your identification
            (ID) number(s) for this coverage:
          </Text>
          <View
            style={{ marginLeft: 12, display: "flex", flexDirection: "row" }}
          >
            <View
              style={{
                display: "flex",
                flexDirection: "column",
                width: 175,
                marginLeft: 10,
              }}
            >
              <Text style={{}}>Name of other coverage:</Text>
              <Text>{props.pdfData.nameOfCoverage}</Text>
              <Text style={{ marginTop: 10 }}></Text>
              <Text style={styles.underLine}></Text>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "column",
                width: 140,
                marginLeft: 10,
              }}
            >
              <Text>ID # for this coverage:</Text>
              <Text>{props.pdfData.covMemberNumber}</Text>
              <Text style={{ marginTop: 10 }}></Text>
              <Text style={styles.underLine}></Text>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "column",
                width: 130,
                marginBottom: 12,
                marginLeft: 10,
              }}
            >
              <Text>Group # for this coverage</Text>
              <Text>{props.pdfData.covGroupNumber}</Text>
              <Text style={{ marginTop: 10 }}></Text>
              <Text style={styles.underLine}></Text>
            </View>
          </View>
          <Text style={styles.underLine}></Text>
          {/* <View style={{margin:12,fontSize:12,marginBottom:5}}>
                  <View style={{fontSize:12,marginTop:0,display:"flex",flexDirection:"row",marginBottom:5}}>
                  <Text style={{marginRight:4}}>
                  2. Are you a resident in a long-term care facility, such as a nursing home?
                  </Text>
                  <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:4}}>
                    Yes
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text>
                    No
                   </Text>
                  </View>
                  <Text style={{marginBottom:5}}>
                If “yes,” please provide the following information:
                  </Text>
                  <View style={{display:"flex",flexDirection:"row",marginBottom:5}}>
                    <Text>
                    Name of Institution:
                    </Text>
                    <View style={{display:"flex",flexDirection:"column",}}>
                    <Text>
                      NIT
                    </Text>
                    <Text style={styles.underLine}></Text>
                    </View>
                    
                  </View>
                  <View style={{display:"flex",flexDirection:"row"}}>
                    <Text>
                    Address & Phone Number of Institution (number and street):
                    </Text>
                    <View style={{display:"flex",flexDirection:"column",}}>
                    <Text>
                      Khadagpur
                    </Text>
                    <Text style={styles.underLine}></Text>
                    </View>
                    
                  </View>
                </View>
                <Text style={styles.underLine}></Text>
                <View style={{margin:12,fontSize:12,marginBottom:5}}>
                <View style={{fontSize:12,marginTop:0,display:"flex",flexDirection:"row",marginBottom:5}}>
                  <Text style={{marginRight:4}}>
                  3. Are you enrolled in your State Medicaid program?
                  </Text>
                  <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:4}}>
                    Yes
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text>
                    No
                   </Text>
                  </View>
                  <View style={{display:"flex",flexDirection:"row"}}>
                    <Text>
                    If yes, please provide your Medicaid number:
                    </Text>
                    <View style={{display:"flex",flexDirection:"column",}}>
                    <Text>
                      9898989898
                    </Text>
                    <Text style={styles.underLine}></Text>
                    </View>
                    
                  </View>
                </View>
                <Text style={styles.underLine}></Text> */}
          <View style={{ margin: 12, fontSize: 12, marginBottom: 5 }}>
            <Text
              style={{
                paddingBottom: 6,
                fontSize: 10,
                fontFamily: "Helvetica-Bold",
              }}
            >
              Answering these questions is your choice. You can’t be denied
              coverage because you don’t fill them out.
            </Text>
            <Text style={{ paddingBottom: 4 }}>
              Are you Hispanic, Latino/a, or Spanish origin? Select all that
              apply.
            </Text>
            <View
              style={{
                fontSize: 12,
                marginTop: 0,
                display: "flex",
                flexDirection: "column",
                marginBottom: 6,
              }}
            >
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "NA" && item?.piCode === "ETHNICITY"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 21 }}>
                  No, not of Hispanic, Latino/a, or Spanish origin
                </Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "MX" && item?.piCode === "ETHNICITY"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text>Yes, Mexican, Mexican American, Chicano/a</Text>
              </View>
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "PR" && item?.piCode === "ETHNICITY"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 165 }}>Yes, Puerto Rican</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "CUB" && item?.piCode === "ETHNICITY"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text>Yes, Cuban</Text>
              </View>
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 7,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "OTH" && item?.piCode === "ETHNICITY"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 11 }}>
                  Yes, another Hispanic, Latino/a, or Spanish origin
                </Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "NR" && item?.piCode === "ETHNICITY"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ fontSize: 12 }}>I choose not to answer.</Text>
              </View>
            </View>
            <Text style={{ paddingBottom: 4 }}>
              What’s your race? Select all that apply.
            </Text>
            <View
              style={{
                fontSize: 12,
                marginTop: 0,
                display: "flex",
                flexDirection: "column",
                marginBottom: 6,
              }}
            >
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "300" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 45 }}>
                  American Indian or Alaska Native
                </Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "401" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 45 }}>Asian Indian</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "201" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text>Black or African American</Text>
              </View>
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "411" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 170 }}>Chinese</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "421" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 69 }}>Filipino</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "521" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text>Guamanian or Chamorro</Text>
              </View>
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "431" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 166 }}>Japanese</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "441" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 72 }}>Korean</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "501" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text>Native Hawaiian</Text>
              </View>
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "499" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 152 }}>Other Asian</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "599" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 1 }}>Other Pacific Islander</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "511" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text>Samoan</Text>
              </View>
              <View
                style={{
                  fontSize: 12,
                  marginTop: 0,
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 3,
                }}
              >
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "451" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 153 }}>Vietnamese</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "101" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 78 }}>White</Text>
                <Image
                  src={
                    props.pdfData?.ethnicityRace?.some(
                      (item) =>
                        item?.piValue === "999" && item?.piCode === "RACE"
                    )
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ fontSize: 12 }}>I choose not to answer.</Text>
              </View>
            </View>
          </View>
          <Text style={styles.underLine}></Text>

          <View style={{ margin: 12, fontSize: 12, marginBottom: 5 }}>
            <View
              style={{
                fontSize: 12,
                marginTop: 0,
                display: "flex",
                flexDirection: "row",
                marginBottom: 5,
              }}
            >
              <Text style={{ marginRight: 4 }}>
                2. Do you or your spouse work?
              </Text>
              <Image
                src={props.pdfData.isSpouseWork === "Y" ? Check : Uncheck}
                alt="Image"
                style={{ width: 12, height: 12, marginRight: 4 }}
              />
              <Text style={{ marginRight: 4 }}>Yes</Text>
              <Image
                src={props.pdfData.isSpouseWork === "N" ? Check : Uncheck}
                alt="Image"
                style={{ width: 12, height: 12, marginRight: 4 }}
              />
              <Text>No</Text>
            </View>
          </View>
          <Text style={styles.underLine}></Text>
          <View style={{ margin: 12, fontSize: 12, marginBottom: 5 }}>
            <View
              style={{
                fontSize: 12,
                marginTop: 0,
                display: "flex",
                flexDirection: "row",
                marginBottom: 5,
              }}
            >
              <Text style={{ fontFamily: "Times-Italic" }}>
                Optional field:
              </Text>
              <Text style={{ fontFamily: "Times-Bold" }}>
                Please choose the name of a Primary Care Physician (PCP), clinic
                or health center:
              </Text>
            </View>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 8 }}
            >
              <Text>Name:</Text>
              <View style={{ display: "flex", flexDirection: "column" }}>
                <Text>{props.pdfData.pcpName}</Text>
                <Text style={styles.underLine}></Text>
              </View>
            </View>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 8 }}
            >
              <Text>Provider code:</Text>
              <View style={{ display: "flex", flexDirection: "column" }}>
                <Text>{props.pdfData?.officeCd ?? ""}</Text>
                <Text style={styles.underLine} />
              </View>
            </View>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 8 }}
            >
              <Text>Address:</Text>
              <View style={{ display: "flex", flexDirection: "column" }}>
                <Text>
                  {props?.pdfData?.pcpDetails?.address
                    ? props?.pdfData?.pcpDetails?.address?.split(",")[0]
                    : props.pdfData.pcpAddr
                    ? props.pdfData.pcpAddr?.split(",")[0]
                    : ""}
                </Text>
                <Text style={styles.underLine}></Text>
              </View>
            </View>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 8 }}
            >
              <View
                style={{ display: "flex", flexDirection: "row", width: 200 }}
              >
                <Text>City:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>
                    {props?.pdfData?.pcpDetails?.address
                      ? props?.pdfData?.pcpDetails?.address?.split(",")[1]
                      : props.pdfData.pcpAddr
                      ? props.pdfData.pcpAddr?.split(",")[1]
                      : ""}
                  </Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: 130,
                  marginLeft: 5,
                }}
              >
                <Text>State:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>
                    {/* {props.pdfData.pcpName
                      ? props.pdfData.permanentAddress.state
                      : ""} */}
                    {props?.selectedVo?.pcpState
                      ? props.selectedVo?.pcpState
                      : props?.selectedVo?.state
                      ? props?.selectedVo?.state
                      : props?.pdfData?.pcpDetails?.state}
                  </Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: 130,
                  marginLeft: 5,
                }}
              >
                <Text>Zip Code:</Text>
                <View style={{ display: "flex", flexDirection: "column" }}>
                  <Text>
                    {/* {props.pdfData.pcpName
                      ? props.pdfData.permanentAddress.zipCode
                      : ""} */}
                    {props?.selectedVo.pcpZip
                      ? props?.selectedVo?.pcpZip
                      : props?.selectedVo?.zipcode
                      ? props?.selectedVo?.zipcode
                      : props?.pdfData?.pcpDetails?.zipcode}
                  </Text>
                  <Text style={styles.underLine}></Text>
                </View>
              </View>
            </View>
          </View>
          <Text style={styles.underLine}></Text>
          <View style={{ margin: 12, fontSize: 12, marginBottom: 5 }}>
            <View
              style={{
                fontSize: 12,
                marginTop: 0,
                display: "flex",
                flexDirection: "column",
                marginBottom: 5,
                fontFamily: "Times-Bold",
              }}
            >
              <Text>
                Please check one of the boxes below if you would prefer us to
                send you information in a
              </Text>
              <Text>
                language other than English or in an accessible format:
              </Text>
            </View>
            <View
              style={{
                fontSize: 12,
                marginTop: 0,
                display: "flex",
                flexDirection: "column",
                marginBottom: 5,
              }}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 8,
                }}
              >
                <Image
                  src={(props.pdfData?.prefLng==="SPA") ? Check : Uncheck}
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 4 }}>Spanish</Text>
              </View>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 8,
                }}
              >
                <Image
                  src={
                    props.pdfData.accessibleFormatVal === "LARGEPRINT"|| props.pdfData.accessibleFormatVal === "L"
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 4 }}>Large print</Text>
              </View>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <Image
                  src={
                    props.pdfData.accessibleFormatVal === "BRAILLE"||props.pdfData.accessibleFormatVal === "B"
                      ? Check
                      : Uncheck
                  }
                  alt="Image"
                  style={{ width: 12, height: 12, marginRight: 4 }}
                />
                <Text style={{ marginRight: 4 }}>Braille</Text>
              </View>
            </View>
          </View>
          <View style={{ margin: 12, fontSize: 12 }}>
            <Text>
              {
                "Please contact Wipro Elite at <1-888-123-1111> if you need information in an accessible format"
              }
            </Text>
            <Text>
              or language other than what is listed above. Our office hours are
              8 am to 8 pm, 7 days a week from October 1 to March 31. From April
              1 through September 30, we are open Monday through Friday, 8 am to
              8 pm. On certain holidays and weekends from April 1 through
              September 30, your call will be handled by our automated phone
              system. TTY users should call 711.
            </Text>
          </View>
        </View>
        <Text style={{ textAlign: "right", fontSize: 11, paddingTop: 280 }}>
          {"<H1234_0123_WIP2-001235_W>"}
        </Text>
      </Page>
      <Page size="A4" wrap={false} style={styles.document}>
        <View style={styles.page3Container}>
          <View
            style={{
              paddingBottom: 6,
              fontSize: 13,
              fontFamily: "Helvetica-Bold",
              textAlign: "center",
              backgroundColor: "#DCDCDC",
            }}
          >
            <Image
              src={Stop}
              alt="image"
              style={{ width: 41, height: 41, marginLeft: 240, marginTop: 12 }}
            ></Image>
            <Text
              style={{
                marginTop: 8,
                marginBottom: 4,
                fontFamily: "Helvetica-Bold",
              }}
            >
              Please Read This Important Information:
            </Text>
          </View>
          <Text style={styles.underLine}></Text>
          <View
            style={{
              marginLeft: 12,
              marginTop: 9,
              marginBottom: 8,
              marginRight: 12,
            }}
          >
            <View>
              <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 11 }}>
                If you currently have health coverage from an employer or union,
                joining Wipro Elite could affect your employer or union health
                benefits. You could lose your employer or union health
              </Text>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 11 }}>
                  coverage if you join Wipro Elite.{" "}
                </Text>
                <Text>
                  Read the communications your employer or union sends
                </Text>
              </View>
              <Text>
                you. If you have questions, visit their website, or contact the
                office listed in their communications. If there isn’t any
                information on whom to contact, your benefits administrator or
                the office that answers questions about your coverage can help.
              </Text>
            </View>
          </View>
          <Text style={styles.underLine}></Text>
          <View
            style={{
              paddingBottom: 6,
              fontSize: 13,
              fontFamily: "Helvetica-Bold",
              textAlign: "center",
              backgroundColor: "#DCDCDC",
            }}
          >
            <Text
              style={{
                marginTop: 8,
                marginBottom: 4,
                fontFamily: "Helvetica-Bold",
              }}
            >
              Please Read and Sign Below
            </Text>
          </View>
          <Text style={styles.underLine}></Text>

          <View
            style={{
              marginLeft: 12,
              marginTop: 9,
              marginBottom: 8,
              marginRight: 12,
            }}
          >
            <View
              style={{
                marginBottom: 12,
                display: "flex",
                flexDirection: "column",
                fontSize: 11,
              }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold" }}>
                By completing this enrollment application, I agree to the
                following:
              </Text>
              <Text style={styles.underLine}></Text>
            </View>
            <View style={{ marginBottom: 12 }}>
              <Text>
                Wipro Elite is a Medicare Advantage plan and has a contract with
                the Federal government. I will need to keep my Medicare Parts A
                and B. I can be in only one Medicare Advantage plan at a time,
                and I understand that my enrollment in this plan will
                automatically end my enrollment in another Medicare health plan
                or prescription drug plan. It is my responsibility to inform you
                of any prescription drug coverage that I have or may get in the
                future. Enrollment in this plan is generally for the entire
                year. Once I enroll, I may leave this plan or make changes only
                at certain times of the year when an
              </Text>
              <Text>
                {
                  "enrollment period is available (Example: October 15 – December 7 of every year), or under certain special circumstances."
                }
              </Text>
            </View>
            <View style={{ marginBottom: 12 }}>
              <Text>
                Wipro Elite serves a specific service area. If I move out of the
                area that Wipro Elite serves, I need to notify the plan so I can
                disenroll and find a new plan in my new area. Once I am a member
                of Wipro Elite, I have the right to appeal plan decisions about
                payment or services if I disagree. I will read the Evidence of
                Coverage document from Wipro Elite when I get it to know which
                rules I must follow to get coverage with this Medicare Advantage
                plan. I understand that people with
              </Text>
              <Text>
                {
                  "Medicare aren’t usually covered under Medicare while out of the country except for limited coverage"
                }
              </Text>
              <Text>near the U.S. border.</Text>
            </View>
            <View style={{ marginBottom: 12 }}>
              <View>
                <Text>
                  I understand that beginning on the date Wipro Elite coverage
                  begins, I must get all of my health care from Wipro Elite,
                  except for emergency or urgently needed services or
                  out-of-area dialysis services. Services authorized by Wipro
                  Elite and other services contained in my Wipro Elite
                </Text>
                <Text>
                  {
                    "Evidence of Coverage document (also known as a member contract or subscriber agreement) will be"
                  }
                </Text>
              </View>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <Text>covered. Without authorization,</Text>
                <Text
                  style={{
                    fontFamily: "Helvetica-Bold",
                    fontSize: 11,
                    marginTop: 3,
                  }}
                >
                  {" "}
                  NEITHER MEDICARE NOR Wipro Elite WILL PAY FOR THE
                </Text>
              </View>
              <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 11 }}>
                SERVICES
              </Text>
            </View>
            <View style={{ marginBottom: 12 }}>
              <Text>
                understand that if I am getting assistance from a sales agent,
                broker, or other individual employed by
              </Text>
              <Text>
                {
                  "or contracted with Wipro Elite, he/she may be paid based on my enrollment in Wipro Elite"
                }
              </Text>
            </View>
            <View style={{ marginBottom: 12 }}>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <Text style={styles.underLine}>
                  <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 11 }}>
                    Release of Information
                  </Text>
                </Text>
                <Text>
                  {" "}
                  : By joining this Medicare health plan, I acknowledge that
                  Wipro Elite
                </Text>
              </View>
              <Text>
                will release my information to Medicare and other plans as is
                necessary for treatment, payment and health care operations. I
                also acknowledge that Wipro Elite will release my information
                including my prescription drug event data to Medicare, who may
                release it for research and other purposes which follow all
                applicable Federal statutes and regulations. The information on
                this enrollment form
              </Text>
            </View>
          </View>
        </View>
        <Text style={{ textAlign: "right", fontSize: 11, paddingTop: 60 }}>
          {"<H1234_0123_WIP2-001235_W>"}
        </Text>
      </Page>
      <Page size="A4" wrap={false} style={styles.document}>
        <View style={styles.page3Container}>
          <View
            style={{
              marginLeft: 12,
              marginTop: 9,
              marginBottom: 12,
              marginRight: 12,
            }}
          >
            <Text>
              is correct to the best of my knowledge. I understand that if I
              intentionally provide false information on this form, I will be
              disenrolled from the plan.
            </Text>
          </View>
          <View
            style={{
              marginLeft: 12,
              marginTop: 3,
              marginBottom: 8,
              marginRight: 12,
            }}
          >
            <Text>
              {
                "I understand that my signature (or the signature of the person authorized to act on my behalf under the"
              }
            </Text>
            <Text>
              {
                "laws of the State where I live) on this application means that I have read and understand the contents "
              }
            </Text>

            <Text>
              {
                "of this application. If signed by an authorized individual (as described above), this signature certifies"
              }
            </Text>
            <Text>
              {
                "that 1) this person is authorized under State law to complete this enrollment and 2) documentation of"
              }
            </Text>
            <Text>this authority is available upon request from Medicare</Text>
          </View>
        </View>
        <View style={{ marginTop: 12 }}></View>
        <View style={styles.page3Container}>
          <View style={{ marginLeft: 12, marginRight: 12 }}>
            <View style={{ display: "flex", flexDirection: "row" }}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 12,
                  marginBottom: 8,
                }}
              >
                <View
                  style={{ display: "flex", flexDirection: "row", width: 300 }}
                >
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>
                    Signature:{" "}
                  </Text>
                  {/* <Text>{props.pdfData.signature}</Text> */}
                  {props.pdfData.applcat === "E-ENROLL AGENT" ? (
                    <Image
                      src={
                        props.pdfData?.agentSign
                          ? props.pdfData?.agentSign
                          : props.pdfData?.attachmentList?.length > 0
                          ? props.pdfData?.attachmentList.filter(
                              (attachment) =>
                                attachment.attachmentType === "SIGNATURE"
                            )[0].sign
                          : props?.attachment?.length > 0
                          ? props?.attachment.filter(
                              (attachmnt) =>
                                attachmnt.attachmentType === "SIGNATURE"
                            )[0].sign
                          : ""
                      }
                      alt="image"
                      style={{ width: 130, height: 30, marginLeft: 40 }}
                    ></Image>
                  ) : (
                    <Text>{props.pdfData.signature}</Text>
                  )}
                </View>
              </View>
              <Text style={styles.verticalLine}></Text>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 12,
                  marginBottom: 8,
                }}
              >
                <Text style={{ fontFamily: "Helvetica-Bold" }}>
                  {"Today’s Date: "}
                </Text>
                <Text>{props.pdfData.todayDate}</Text>
              </View>
            </View>
          </View>
          <Text style={styles.underLine}></Text>
          <View style={{ marginLeft: 12, marginRight: 12, marginTop: 12 }}>
            <Text style={{ marginBottom: 8 }}>
              If you are the authorized representative, you must sign above and
              provide the following information:
            </Text>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                Name:
              </Text>
              <Text
                style={props.pdfData.nameOfRep !== "" ? styles.underLine : {}}
              >
                {props.pdfData.nameOfRep +
                  " " +
                  (props.pdfData.middleNameOfRep
                    ? props.pdfData.middleNameOfRep
                    : "") +
                  " " +
                  (props.pdfData.lastNameOfRep
                    ? props.pdfData.lastNameOfRep
                    : "")}
              </Text>
            </View>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                Address:
              </Text>
              <Text style={styles.underLine}>
                {(props.pdfData?.authRepAddress?.streetAddress!== "" && props.pdfData?.authRepAddress?.streetAddress !== null)&&props.pdfData?.authRepAddress?.streetAddress +
                  ((props.pdfData?.authRepAddress?.address2 !== "" && props.pdfData?.authRepAddress?.address2 !== null)
                    ? ",  " + props.pdfData?.authRepAddress?.address2
                    : "") +
                  ((props.pdfData?.authRepAddress?.address3 !== "" && props.pdfData?.authRepAddress?.address3 !== null)
                    ? ",  " + props.pdfData?.authRepAddress?.address3
                    : "")}
              </Text>
            </View>
            {/* <View style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}>
              <Text style={{ fontFamily: "Helvetica-Bold",marginRight:10 }}>Address2:</Text>
              <Text style={styles.underLine}>{props.pdfData.authRepAddress.address2}</Text>
            </View>
            <View style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}>
              <Text style={{ fontFamily: "Helvetica-Bold",marginRight:10 }}>Address3:</Text>
              <Text style={styles.underLine}>{props.pdfData.authRepAddress.address3}</Text>
            </View> */}
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                City:
              </Text>
              <Text style={styles.underLine}>
                {props.pdfData.authRepAddress.city}
              </Text>
            </View>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                State:
              </Text>
              <Text style={styles.underLine}>
                {props.pdfData.authRepAddress.state}
              </Text>
            </View>
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                Zip:
              </Text>

              <Text style={styles.underLine}>
                {props.pdfData.authRepAddress.zip4
                  ? props.pdfData.authRepAddress.zipCode +
                    "-" +
                    props.pdfData.authRepAddress.zip4
                  : props.pdfData.authRepAddress.zipCode}
              </Text>
            </View>
            {/* <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                Zip+4:
              </Text>
              <Text style={styles.underLine}>
                {props.pdfData.authRepAddress.zip4}
              </Text>
            </View> */}
            <View
              style={{ display: "flex", flexDirection: "row", marginBottom: 4 }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                Phone Number:
              </Text>
              <Text style={styles.underLine}>
                {props.pdfData.phoneNumberOfRep?.length === 10
                  ? "(" +
                    props.pdfData.phoneNumberOfRep.slice(0, 3) +
                    ") " +
                    props.pdfData.phoneNumberOfRep.slice(3, 6) +
                    " -" +
                    props.pdfData.phoneNumberOfRep.slice(6)
                  : props.pdfData.phoneNumberOfRep}
              </Text>
            </View>
            <View
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 12,
              }}
            >
              <Text style={{ fontFamily: "Helvetica-Bold", marginRight: 10 }}>
                Relationship to Enrollee:
              </Text>
              <Text style={styles.underLine}>
                {props.pdfData?.authReln
                  ? props.pdfData.authReln
                  : props.authorizedrelations &&
                    props.authorizedrelations?.filter(
                      (data) => data.value == props.pdfData?.relationOfRep
                    )[0]?.label === "---Select---"
                  ? ""
                  : props.authorizedrelations &&
                    props.authorizedrelations?.filter(
                      (data) => data.value == props.pdfData?.relationOfRep
                    )[0]?.label}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginTop: 12 }}></View>
        {/* <View style={styles.page3Container}>
          <View style={{paddingBottom:6,fontSize:13,fontFamily:"Helvetica-Bold",textAlign:"center",backgroundColor:"#DCDCDC",}}>
              <Text style={{fontFamily:"Helvetica-Bold",marginTop:8,}}>Applicant: Please do not complete the following sections</Text>
              <Text style={{fontFamily:"Helvetica-Bold"}}>Agent/Broker: Please fill in ALL fields below</Text>
          </View>
          <Text style={styles.underLine}></Text>
          <View style={{marginLeft:10,marginRight:10,marginTop:10}}>
            <View style={{display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>Coverage effective date:   </Text>
                  <Text style={styles.underLine}>{props.pdfData.proposedEffDate}</Text>
                  <Text style={{marginLeft:7}}>PLAN ID #: H9877_001</Text>
            </View>
            <View style={{fontSize:12,marginTop:0,display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:8}}>
                   IEP/ICEP      
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:8}}>
                   AEP      
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:8}}>
                   OEP         
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:8}}>
                   SEP(type):          
                   </Text>
                   <Text style={styles.underLine}>Do not Know   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text>
                   Not eligible 
                   </Text>
            </View>
            <View style={{fontSize:12,marginTop:0,display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>I helped the applicant fill out this application.         </Text>
                  <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:4}}>
                  Yes       
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:4}}>
                  No       
                   </Text>
            </View>
            <View style={{fontSize:12,marginTop:0,display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>Was this an individual face-to-face appointment?         </Text>
                  <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:4}}>
                  Yes       
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:4}}>
                  No       
                   </Text>
            </View>
            <Text style={{marginBottom:15}}>If yes, how was a scope of appointment (SOA) collected?</Text>
            <View style={{fontSize:12,marginTop:0,display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:12}}>
                   Paper   
                   </Text>
                   <Image
                    src={Uncheck}
                    alt="Image"
                    style={{width:12,height:12,marginRight:4}}
                   />
                   <Text style={{marginRight:12}}>
                   Recorded call  
                   </Text>
                   <Text style={{marginRight:4}}>
                   Date recorded          
                   </Text>
                   <Text style={styles.underLine}>11/09/2002</Text>
                   <Text style={{marginRight:6,marginLeft:9}}>
                   Time recorded           
                   </Text>
                   <Text style={styles.underLine}>Do not Know   </Text>
                   <Text style={{marginLeft:7}}>
                   EST. AM/PM
                   </Text>
            </View>
          </View>
          <Text style={styles.underLine}></Text>
          <View style={{marginLeft:10,marginRight:10,marginTop:10}}>
          <View style={{display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>Print Name:  </Text>
                  <View style={{display:"flex",flexDirection:"column",marginRight:15}}>
                  <Text style={styles.underLine}>teenu sunny</Text>
                  <Text style={{fontSize:9,marginLeft:30}}>First</Text>
                  </View>
                  <View style={{display:"flex",flexDirection:"column"}}>
                  <Text style={styles.underLine}>sunny</Text>
                  <Text style={{fontSize:9,marginLeft:30}}>Last</Text>
                  </View>
                  
            </View>
          <View style={{display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>{"Writing Agent Producer Number (P-Number):  "}</Text>
                  <Text style={styles.underLine}>10987655</Text>
          </View>
          <View style={{display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>Phone:  </Text>
                  <Text style={styles.underLine}>10987655</Text>
                  <Text style={{marginLeft:250}}>Fax:  </Text>
                  <Text style={styles.underLine}>10987655</Text>
          </View>
          <View style={{display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>Email:  </Text>
                  <Text style={styles.underLine}>agf@gmail.com</Text>
          </View>
          <View style={{display:"flex",flexDirection:"row",marginBottom:15}}>
                  <Text>Signature:  </Text>
                  <Text style={styles.underLine}>uerfgjhsf</Text>
                  <Text style={{marginLeft:180}}>Application received date:  </Text>
                  <Text style={styles.underLine}>10/98/7655</Text>
          </View>
          </View>
        </View> */}
        <Text style={{ textAlign: "right", fontSize: 11, paddingTop: 480 }}>
          {"<H1234_0123_WIP2-001235_W>"}
        </Text>
      </Page>
      <Page size="A4" wrap={false} style={styles.document}>
        <View style={{ fontFamily: "Helvetica", fontSize: 12 }}>
          <Text style={{ fontFamily: "Helvetica-Bold", marginBottom: 8 }}>
            Attestation of Eligibility for an Enrollment Period
          </Text>
          <Text style={{ marginBottom: 12 }}>Referenced in section: 30.4</Text>
          <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 11 }}>
            Typically, you may enroll in a Medicare Advantage plan only during
            the annual enrollment period{" "}
          </Text>
          <View style={{ display: "flex", flexDirection: "row" }}>
            <Text style={{ fontFamily: "Helvetica-Bold", fontSize: 11 }}>
              from October 15 through December 7 of each year.{" "}
            </Text>
            <Text style={{ fontSize: 11 }}>
              There are exceptions that may allow you to enroll in a
            </Text>
          </View>
          <Text style={{ marginBottom: 10 }}>
            Medicare Advantage plan outside of this period.
          </Text>
          <Text style={{ marginBottom: 12 }}>
            Please read the following statements carefully and check the box if
            the statement applies to you. By checking any of the following boxes
            you are certifying that, to the best of your knowledge, you are
            eligible for an Enrollment Period. If we later determine that this
            information is incorrect, you may be disenrolled.
          </Text>
        </View>
        <View
          style={{
            fontSize: 12,
            display: "flex",
            flexDirection: "row",
            marginBottom: 15,
          }}
        >
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "1"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            I am enrolled in a Medicare Advantage plan and want to make a change
            during the Medicare Advantage Annual Enrollment Period (AEP),
            October 15 through December 7
          </Text>
        </View>
        <View
          style={{
            fontSize: 12,
            display: "flex",
            flexDirection: "row",
            marginBottom: 15,
          }}
        >
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "2"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>I am new to Medicare.</Text>
        </View>
        <View
          style={{
            fontSize: 12,
            display: "flex",
            flexDirection: "row",
            marginBottom: 15,
          }}
        >
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "31"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            I am enrolled in a Medicare Advantage plan and want to make a change
            during the Medicare Advantage Open Enrollment Period (MA OEP).
          </Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "3"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <View>
            <Text style={{ marginTop: -2 }}>
              I recently moved outside of the service area for my current plan
              or I recently moved and this plan
            </Text>
            <View style={{ display: "flex", flexDirection: "row" }}>
              <Text>is a new option for me. I moved on (insert date)</Text>
              <Text>
                {props.pdfData.attestationList?.length > 0
                  ? props.pdfData.attestationList?.some(
                      (id) => id?.qsnMetaId === "3"
                    )
                    ? props.pdfData.attestationList.filter(
                        (attst) =>
                          attst.qsnMetaId ===
                          props.pdfData.qsns.filter(
                            (data2) => data2.questionId === "3"
                          )[0]?.answersvo[0]?.subQuestions
                      )[0]?.answer
                    : ""
                  : ""}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginLeft: 270, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "4"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2, marginLeft: 3 }}>
            I recently was released from incarceration. I was released on
            (insert date)
          </Text>
          <Text>
            {props.pdfData.attestationList?.length > 0
              ? props.pdfData.attestationList?.some(
                  (id) => id?.qsnMetaId === "4"
                )
                ? props.pdfData.attestationList.filter(
                    (attst) =>
                      attst.qsnMetaId ===
                      props.pdfData.qsns.filter(
                        (data2) => data2.questionId === "4"
                      )[0]?.answersvo[0]?.subQuestions
                  )[0]?.answer
                : ""
              : ""}
          </Text>
        </View>
        <View style={{ marginLeft: 420, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "5"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <View>
            <Text style={{ marginTop: -2 }}>
              I recently returned to the United States after living permanently
              outside of the U.S. I returned to
            </Text>
            <View style={{ display: "flex", flexDirection: "row" }}>
              <Text>the U.S. on (insert date)</Text>
              <Text>
                {props.pdfData.attestationList?.length > 0
                  ? props.pdfData.attestationList?.some(
                      (id) => id?.qsnMetaId === "5"
                    )
                    ? props.pdfData.attestationList.filter(
                        (attst) =>
                          attst.qsnMetaId ===
                          props.pdfData.qsns.filter(
                            (data2) => data2.questionId === "5"
                          )[0]?.answersvo[0]?.subQuestions
                      )[0]?.answer
                    : ""
                  : ""}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginLeft: 140, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "6"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            I recently obtained lawful presence status in the United States. I
            got this status on
          </Text>
        </View>
        <View style={{ display: "flex", flexDirection: "row" }}>
          <Text style={{ fontSize: 12, marginLeft: 25 }}>(insert date) </Text>
          <Text style={{ fontSize: 12 }}>
            {props.pdfData.attestationList?.length > 0
              ? props.pdfData.attestationList?.some(
                  (id) => id?.qsnMetaId === "6"
                )
                ? props.pdfData.attestationList.filter(
                    (attst) =>
                      attst.qsnMetaId ===
                      props.pdfData.qsns.filter(
                        (data2) => data2.questionId === "6"
                      )[0]?.answersvo[0]?.subQuestions
                  )[0]?.answer
                : ""
              : ""}
          </Text>
        </View>

        <View style={{ marginLeft: 90, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "17"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            I recently had a change in my Medicaid (newly got Medicaid, had a
            change in level of Medicaid
          </Text>
        </View>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            fontSize: 12,
            marginLeft: 30,
          }}
        >
          <Text>assistance, or lost Medicaid) on (insert date)</Text>
          <Text>
            {props.pdfData.attestationList?.length > 0
              ? props.pdfData.attestationList?.some(
                  (id) => id?.qsnMetaId === "17"
                )
                ? props.pdfData.attestationList.filter(
                    (attst) =>
                      attst.qsnMetaId ===
                      props.pdfData.qsns.filter(
                        (data2) => data2.questionId === "17"
                      )[0]?.answersvo[0]?.subQuestions
                  )[0]?.answer
                : ""
              : ""}
          </Text>
        </View>
        <View style={{ marginLeft: 270, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "18"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <View style={{ display: "flex", flexDirection: "column" }}>
            <Text style={{ marginTop: -2 }}>
              I recently had a change in my Extra Help paying for Medicare
              prescription drug coverage (newly
            </Text>
            <Text>
              got Extra Help, had a change in the level of Extra Help, or lost
              Extra Help) on (insert date)
            </Text>
          </View>
        </View>
        <View
          style={{
            marginLeft: 30,
            width: 80,
            marginBottom: 15,
            fontSize: 12,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Text style={{ marginBottom: 0, marginTop: 5 }}>
            {props.pdfData.attestationList?.length > 0
              ? props.pdfData.attestationList?.some(
                  (id) => id?.qsnMetaId === "18"
                )
                ? props.pdfData.attestationList.filter(
                    (attst) =>
                      attst.qsnMetaId ===
                      props.pdfData.qsns.filter(
                        (data2) => data2.questionId === "18"
                      )[0]?.answersvo[0]?.subQuestions
                  )[0]?.answer
                : ""
              : ""}
          </Text>
          <Text style={{ marginBottom: 3 }}></Text>
          <Text style={styles.underLine}></Text>
        </View>
        <View
          style={{
            fontSize: 12,
            display: "flex",
            flexDirection: "row",
            marginBottom: 15,
          }}
        >
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "7"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <View style={{ display: "flex", flexDirection: "column" }}>
            <Text style={{ marginTop: -2 }}>
              I have both Medicare and Medicaid (or my state helps pay for my
              Medicare premiums) or I get
            </Text>
            <Text>
              Extra Help paying for my Medicare prescription drug coverage, but
              I haven’t had a change.
            </Text>
          </View>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "10"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <View style={{ display: "flex", flexDirection: "column" }}>
            <Text style={{ marginTop: -2 }}>
              I am moving into, live in, or recently moved out of a Long-Term
              Care Facility (for example, a
            </Text>
            <Text>
              nursing home or long term care facility). I moved/will move
              into/out of the facility on (insert date)
            </Text>
          </View>
        </View>
        <View
          style={{
            marginLeft: 30,
            width: 80,
            marginBottom: 15,
            fontSize: 12,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Text style={{ marginTop: 5 }}>
            {props.pdfData.attestationList?.length > 0
              ? props.pdfData.attestationList?.some(
                  (id) => id?.qsnMetaId === "10"
                )
                ? props.pdfData.attestationList.filter(
                    (attst) =>
                      attst.qsnMetaId ===
                      props.pdfData.qsns.filter(
                        (data2) => data2.questionId === "10"
                      )[0]?.answersvo[0]?.subQuestions
                  )[0]?.answer
                : ""
              : ""}
          </Text>
          <Text style={{ marginBottom: 3 }}></Text>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "11"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            I recently left a PACE program on (insert date)
          </Text>
          <Text>
            {props.pdfData.attestationList?.length > 0
              ? props.pdfData.attestationList?.some(
                  (id) => id?.qsnMetaId === "11"
                )
                ? props.pdfData.attestationList.filter(
                    (attst) =>
                      attst.qsnMetaId ===
                      props.pdfData.qsns.filter(
                        (data2) => data2.questionId === "11"
                      )[0]?.answersvo[0]?.subQuestions
                  )[0]?.answer
                : ""
              : ""}
          </Text>
        </View>
        <View style={{ marginLeft: 280, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "12"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <View>
            <Text style={{ marginTop: -2 }}>
              I recently involuntarily lost my creditable prescription drug
              coverage (coverage as good as
            </Text>
            <View style={{ display: "flex", flexDirection: "row" }}>
              <Text>Medicare’s). Ilost my drug coverage on (insert date)</Text>
              <Text>
                {props.pdfData.attestationList?.length > 0
                  ? props.pdfData.attestationList?.some(
                      (id) => id?.qsnMetaId === "12"
                    )
                    ? props.pdfData.attestationList.filter(
                        (attst) =>
                          attst.qsnMetaId ===
                          props.pdfData.qsns.filter(
                            (data2) => data2.questionId === "12"
                          )[0]?.answersvo[0]?.subQuestions
                      )[0]?.answer
                    : ""
                  : ""}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginLeft: 300, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "13"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            I am leaving employer or union coverage on (insert date)
          </Text>
          <Text>
            {props.pdfData.attestationList?.length > 0
              ? props.pdfData.attestationList?.some(
                  (id) => id?.qsnMetaId === "13"
                )
                ? props.pdfData.attestationList.filter(
                    (attst) =>
                      attst.qsnMetaId ===
                      props.pdfData.qsns.filter(
                        (data2) => data2.questionId === "13"
                      )[0]?.answersvo[0]?.subQuestions
                  )[0]?.answer
                : ""
              : ""}
          </Text>
        </View>
        <View style={{ marginLeft: 320, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>
        <View
          style={{
            fontSize: 12,
            display: "flex",
            flexDirection: "row",
            marginBottom: 10,
          }}
        >
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "14"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            I belong to a pharmacy assistance program provided by my state.
          </Text>
        </View>
        <View
          style={{
            fontSize: 12,
            display: "flex",
            flexDirection: "row",
            marginBottom: 15,
          }}
        >
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "15"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <Text style={{ marginTop: -2 }}>
            My plan is ending its contract with Medicare, or Medicare is ending
            its contract with my plan.
          </Text>
        </View>
        <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
          <Image
            src={
              props.pdfData.attestationList?.length > 0
                ? props.pdfData.attestationList?.some(
                    (id) => id?.qsnMetaId === "9"
                  )
                  ? Check
                  : Uncheck
                : Uncheck
            }
            alt="Image"
            style={{ width: 12, height: 12, marginRight: 15 }}
          />
          <View>
            <Text style={{ marginTop: -2 }}>
              I was enrolled in a plan by Medicare (or my state) and I want to
              choose a different plan.
            </Text>
            <View style={{ display: "flex", flexDirection: "row" }}>
              <Text>My enrollment in that plan started on (insert date)</Text>
              <Text>
                {props.pdfData.attestationList?.length > 0
                  ? props.pdfData.attestationList?.some(
                      (id) => id?.qsnMetaId === "9"
                    )
                    ? props.pdfData.attestationList.filter(
                        (attst) =>
                          attst.qsnMetaId ===
                          props.pdfData.qsns.filter(
                            (data2) => data2.questionId === "9"
                          )[0]?.answersvo[0]?.subQuestions
                      )[0]?.answer
                    : ""
                  : ""}
              </Text>
            </View>
          </View>
        </View>
        <View style={{ marginLeft: 290, width: 80, marginBottom: 15 }}>
          <Text style={styles.underLine}></Text>
        </View>

        {/* <View style={{fontSize:12,display:"flex",flexDirection:"row",marginBottom:15}}>
          <Image
            src={Uncheck}
            alt="Image"
            style={{width:12,height:12,marginRight:15}}
          />
          <Text style={{marginTop:-2}}>
          I am enrolled in a Medicare Advantage plan and want to make a change during the Medicare Advantage
          Annual Enrollment Period (AEP).
          </Text>
        </View>  */}

        <Text style={{ textAlign: "right", fontSize: 11, paddingTop: 90 }}>
          {"<H1234_0123_WIP2-001235_W>"}
        </Text>
      </Page>
      <Page size="A4" wrap={false} style={styles.document}>
        <View style={{ fontFamily: "Helvetica", fontSize: 12 }}>
          <View style={{ fontSize: 12, display: "flex", flexDirection: "row" }}>
            <Image
              src={
                props.pdfData.attestationList?.length > 0
                  ? props.pdfData.attestationList?.some(
                      (id) => id?.qsnMetaId === "16"
                    )
                    ? Check
                    : Uncheck
                  : Uncheck
              }
              alt="Image"
              style={{ width: 12, height: 12, marginRight: 15 }}
            />
            <View>
              <Text style={{ marginTop: -2 }}>
                I was enrolled in a Special Needs Plan (SNP) but I have lost the
                special needs qualification{" "}
              </Text>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <Text>
                  required to be in that plan. I was disenrolled from the SNP on
                  (insert date)
                </Text>
                <Text>
                  {props.pdfData.attestationList?.length > 0
                    ? props.pdfData.attestationList?.some(
                        (id) => id?.qsnMetaId === "16"
                      )
                      ? props.pdfData.attestationList.filter(
                          (attst) =>
                            attst.qsnMetaId ===
                            props.pdfData.qsns.filter(
                              (data2) => data2.questionId === "16"
                            )[0]?.answersvo[0]?.subQuestions
                        )[0]?.answer
                      : ""
                    : ""}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ marginLeft: 420, width: 80, marginBottom: 15 }}>
            <Text style={styles.underLine}></Text>
          </View>
          <View
            style={{
              fontSize: 12,
              display: "flex",
              flexDirection: "row",
              marginBottom: 20,
            }}
          >
            <Image
              src={
                props.pdfData.attestationList?.length > 0
                  ? props.pdfData.attestationList?.some(
                      (id) => id?.qsnMetaId === "8"
                    )
                    ? Check
                    : Uncheck
                  : Uncheck
              }
              alt="Image"
              style={{ width: 12, height: 12, marginRight: 15 }}
            />
            <View style={{ display: "flex", flexDirection: "column" }}>
              <Text style={{ marginTop: -2 }}>
                I was affected by an emergency or major disaster (as declared by
                the Federal Emergency Management Agency (FEMA) or by a Federal,
                state or local government entity.
              </Text>
              <Text>
                One of the other statements here applied to me, but I was unable
                to make my enrollment request because of the disaster.
              </Text>
            </View>
          </View>

          <Text>
            If none of these statements applies to you or you’re not sure,
            please contact Wipro Elite at
          </Text>
          <Text>
            {
              "<1-888-123-1111> (TTY users should call 711) to see if you are eligible to enroll. We are open 8 am "
            }
          </Text>
          <Text>
            to 8 pm, 7 days a week from October 1 to March 31. From April 1
            through September 30, we are
          </Text>
          <Text>open Monday through Friday, 8 am to 8 pm. </Text>
        </View>
        <Text style={{ textAlign: "right", fontSize: 11, paddingTop: 530 }}>
          {"<H1234_0123_WIP2-001235_W>"}
        </Text>
      </Page>
    </Document>
  );
}
